import { useMemo } from 'react';

import { Box } from '@mui/material';
import { AxiosError } from 'axios';

import Typography from '@/components/Typography';
import { DATAHUB_TITLES } from '@/features/DataHub/constants/titles';
import { ExportItem } from '@/features/DataHub/pages/PastExports/components/ExportItem';
import { ExportItemsSkeleton } from '@/features/DataHub/pages/PastExports/components/ExportItemsSkeleton';
import { PastExportsEmptyState } from '@/features/DataHub/pages/PastExports/components/PastExportsEmptyState';
import { usePastExports } from '@/features/DataHub/queries';
import useDocumentTitleRename from '@/hooks/useDocumentTitleRename';

export const PastExports = () => {
  useDocumentTitleRename(DATAHUB_TITLES.pastExports);
  const { data, isError, isLoading, error } = usePastExports();
  const isEmpty = data?.length === 0;

  const sortedData = useMemo(
    () => data?.toSorted((a, b) => b.lastExecutionTime - a.lastExecutionTime),
    [data]
  );

  if (isEmpty || (error instanceof AxiosError && error.status === 404))
    return <PastExportsEmptyState />;
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        flex: 1,
        p: '24px',
        overflow: 'auto'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '8px'
        }}
      >
        <Typography
          sx={{
            fontSize: '20px',
            fontWeight: 700
          }}
        >
          Past Exports
        </Typography>
        <Typography
          color='textSecondary'
          sx={{
            fontSize: '14px'
          }}
        >
          Your past exports with details
        </Typography>
      </Box>
      {isLoading && <ExportItemsSkeleton />}
      {isError && <Typography>Error loading data</Typography>}

      {sortedData?.map(item => (
        <ExportItem
          key={item.id}
          item={item}
        />
      ))}
    </Box>
  );
};
